// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__24fkx","modalFooterButton":"ModalNotes_modalFooterButton__3zslE"};